import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/AddBrand.css';
//isso é so um teste
const AddBrand = () => {
  const [formData, setFormData] = useState({ nome: '', imagem: null });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, imagem: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    formDataToSend.append('nome', formData.nome);
    if (formData.imagem) {
      formDataToSend.append('imagem', formData.imagem);
    }

    try {
      await axios.post('https://crmesquita.com.br/api/marcas/', formDataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSuccess('Marca adicionada com sucesso!');
      setTimeout(() => navigate('/produtos'), 2000); // Redireciona após 2 segundos
    } catch (error) {
      setError('Erro ao adicionar marca. Tente novamente.');
    }
  };

  return (
    <div className="add-brand-container">
      <h1 className="title">Adicionar Nova Marca</h1>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}
      <form onSubmit={handleSubmit} className="add-brand-form">
        <input
          type="text"
          name="nome"
          placeholder="Nome da Marca"
          value={formData.nome}
          onChange={handleInputChange}
          required
          className="form-input"
        />
        <input
          type="file"
          name="imagem"
          onChange={handleFileChange}
          className="form-input"
        />
        <button type="submit" className="form-button">
          Adicionar Marca
        </button>
      </form>
    </div>
  );
};

export default AddBrand;